import { siteConfig, fullAddress, isPlaceholder } from "../config/site";
import { useLanguage } from "../i18n/LanguageContext";
import { track } from "../lib/tracking";
import { ICON_3D, Icon3D } from "./Icon3D";

export const ContactCards = ({ compact = false }: { compact?: boolean }) => {
  const { t } = useLanguage();
  const maps = siteConfig.bookingLinks.googleMaps;
  return (
    <div className={`grid gap-4 ${compact ? "" : "sm:grid-cols-2"}`} data-testid="contact-cards">
      {siteConfig.contacts.map((c) => (
        <div key={c.email} className="card group p-6" data-testid={`contact-card-${c.name.split(" ")[0].toLowerCase()}`}>
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-charcoal-400">{c.name}</p>
          <a href={`tel:${c.phoneHref}`} className="mt-4 flex items-center gap-3 font-display text-xl transition-colors hover:text-clay" onClick={() => track("phone_click")} data-testid={`contact-phone-${c.phoneHref}`}>
            <Icon3D src={ICON_3D.phone} size="sm" />{c.phone}
          </a>
          <a href={`mailto:${c.email}`} className="mt-3 flex items-center gap-3 text-sm text-charcoal-700 transition-colors hover:text-clay break-all" onClick={() => track("email_click")} data-testid={`contact-email-${c.name.split(" ")[0].toLowerCase()}`}>
            <Icon3D src={ICON_3D.mail} size="sm" />{c.email}
          </a>
        </div>
      ))}
      <div className={`card group p-6 ${compact ? "" : "sm:col-span-2"}`} data-testid="contact-card-address">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-charcoal-400">{t.common.address}</p>
        <p className="mt-4 flex items-center gap-3 font-display text-xl"><Icon3D src={ICON_3D.pin} size="sm" /><span data-testid="contact-address">{fullAddress()}</span></p>
        {!isPlaceholder(maps) && <a href={maps} target="_blank" rel="noopener noreferrer" className="mt-3 inline-block text-sm text-clay underline underline-offset-2" data-testid="contact-maps-link">{t.location.openMaps}</a>}
      </div>
    </div>
  );
};
